// oui
console.log("%c oui. code " + "%c https://oui-studios.de ", "background: #324047; color: #fff;", "background: transparent; color: #324047");
